import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

// `startedAt` and `prefsConfirmedAt` are now server-authoritative (brand
// columns / persisted prefs), read via useCompanionOnboardingStatus. Only the
// banner dismissal stays client-local: it is a per-browser UI preference, not
// onboarding progress, so it does not need cross-device persistence.
type BrandOnboardingState = {
  bannerDismissedAt: string | null;
};

const emptyBrandState = (): BrandOnboardingState => ({
  bannerDismissedAt: null,
});

type CompanionOnboardingStore = {
  byBrandId: Record<string, BrandOnboardingState>;
  dismissBanner: (brandId: string) => void;
};

export const useCompanionOnboardingStore = create<CompanionOnboardingStore>()(
  devtools(
    persist(
      (set, get) => ({
        byBrandId: {},

        dismissBanner: (brandId) => {
          const existing = get().byBrandId[brandId];
          // Idempotent: do not overwrite an existing bannerDismissedAt
          if (existing?.bannerDismissedAt) return;

          set((state) => ({
            byBrandId: {
              ...state.byBrandId,
              [brandId]: {
                ...(state.byBrandId[brandId] ?? emptyBrandState()),
                bannerDismissedAt: new Date().toISOString(),
              },
            },
          }));
        },
      }),
      {
        name: 'companion-onboarding-storage',
        partialize: (state) => ({ byBrandId: state.byBrandId }),
      }
    ),
    { name: 'CompanionOnboardingStore' }
  )
);
